import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { SubscriptionsManager } from '../util/subscriptions-manager';
import { MethodService } from '../ontology/service/method.service';

@Component({
    selector: 'jhi-column-filter-methods',
    template: `
		<form #f='ngForm'>
			<section class="filter-wrapper">
				<div class="keyword-wrapper">
					<input type="text" class="form-control" [formControl]="queryField" id="keyword" placeholder="{{ methodsPlaceholder | translate }}" autofocus/>
				</div>
				<ul class="filter-select">
					@if (results.length > 0) {
						<li *ngFor="let result of results" class="filter-select-list" (click)="addMethod(result)">
							<div class="result-line mt-2 ms-2">
								<span class="label-info fw-bold">{{ 'column-filter.name' | translate }}:</span>
								<span>{{ result.name }}</span>
							</div>
							<div class="result-line ms-2">
								<span class="label-info fw-bold">{{ 'column-filter.description' | translate }}:</span>
								<span class="result-value">{{ result.description }}</span>
							</div>
						</li>
					}
				</ul>
			</section>
			@if (filter.methods.length === 0) {
				<div class="empty-selection">
					<span>{{ 'column-filter.methods.label' | translate }}</span>
				</div>
			} @else {
				<div class="selected-items-container mt-2">
					<div *ngFor="let method of filter.methods" class="selected-chip">
						<button type="button" class="chip-remove" (click)="deleteMethod(method)" aria-label="Remove method"> ×</button>
						<span class="chip-text">{{ method.name }}</span>
					</div>
				</div>
			}
			<br/>
			<div class="footer text-center">
				<br>
				<button type="submit" class="btn btn-primary btn-sm me-1" [disabled]="!f.valid" (click)="apply(f)">{{ 'apply' | translate }}</button>
				<button type="button" class="btn btn-secondary btn-sm" (click)="reset(f)">{{ 'reset' | translate }}</button>
			</div>
		</form>
    `
})
export class ColumnFilterMethodsComponent implements OnInit, OnDestroy {

    queryField: FormControl = new FormControl();
    results: any[] = [];

    @Input() filter: any;
    @Output() onApply = new EventEmitter();
    @Output() onReset = new EventEmitter();
    methodsPlaceholder: string;

    subscriptionManager = new SubscriptionsManager();

    constructor(private methodService: MethodService) {
    }

    ngOnDestroy(): void {
        this.subscriptionManager.unsubscribeAll();
    }

    ngOnInit(): void {
        this.subscriptionManager.add = this.queryField.valueChanges
            .pipe(
                debounceTime(500),
                distinctUntilChanged(),
                switchMap((query) => this.methodService.queryMethods(query))
            ).subscribe((result) => {
                if (result.status === 400) {
                    this.results = [];
                    return;
                }
                this.results = result.body || [];
            });
        this.methodsPlaceholder = this.filter.placeholder ? this.filter.placeholder : 'column-filter.search.text.placeholder';
    }

    addMethod(method) {
        // Reset query field value
        this.queryField.setValue('');
        // Do not add methods if it's already in the list
        if (!this.filter.methods.some((e) => e.name === method.name)) {
            this.filter.methods.push({ ...method });
        }
    }

    deleteMethod(method) {
        this.filter.methods = this.filter.methods.filter((e) => e.name !== method.name);
    }

    apply(form) {
        if (!form.valid) {
            return;
        }
        this.onApply.emit();
    }

    reset(form) {
        form.reset();
        this.onReset.emit();
    }
}
